import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
const APPROVALS_REMINDER_DPG_ID = {
  prod: 135674940,
  qa: 3971814
};
const approvalsReminderDpgId = enviro.isQa() ? APPROVALS_REMINDER_DPG_ID.qa : APPROVALS_REMINDER_DPG_ID.prod;
export const NOTIFICATION_PREFERENCES_URL = `${getFullUrl('app')}/notification-preferences/${PortalIdParser.get()}/custom-preferences/${approvalsReminderDpgId}`;